import React from "react";
import "./styles.css";

function Projects() {
    return(
    <section className="projects" id="projects">
    <h2 className="pr-heading">Projects</h2>
        <div className="services-container">
         <div className="service-box box-modified">
          <div className="service-info">
          <i class="fa-solid fa-dumbbell"></i>
           <h4>GymStone Protien Shake Website</h4>
           <p>HTML5, CSS3, Bootstrap, and React JS</p>
           <a href="https://gymstone.netlify.app/" className="btn view-btn">View</a>
          </div>
        </div>
        <div className="service-box box-modified">
          <div className="service-info">
          <i class="fa-solid fa-calendar-check"></i>
          <h4>To Do App with Date & Time</h4>
           <p>HTML5, CSS3, Bootstrap, and React JS</p>
           <a href="https://todo-by-dilshair.netlify.app/" className="btn view-btn">View</a>
          </div>
        </div>
        <div className="service-box box-modified">
          <div className="service-info">
          <i class="fa-solid fa-palette"></i>
           <h4>Nex Graphics - Clone Website</h4>
           <p>HTML, CSS3 & Bootstrap</p>
           <a href="https://nexgraphics-by-dilshair.netlify.app/" className="btn view-btn">View</a>
          </div>
        </div>
        </div>
        <div className="btn-group" style={{marginTop:"4rem", gap:"1.5", alignItems:"center" }}>
        <a href="https://drive.google.com/file/d/1319BvjWp5vdF1vi0AzzTDglTQsAWDLEz/view?usp=sharing" 
         className="btn">Download Resume <i class="fa-solid fa-circle-down"></i></a>
        {/* <a href="https://drive.google.com/file/d/11hFcQ2wpUJqPaZ6_U33kDnnuuD4yfSXH/view?usp=sharing" 
         className="btn">Customer Support Executive <i class="fa-solid fa-circle-down"></i></a> */}
        </div>
    </section>

    )
}

export default Projects;